'use strict';
var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis([].slice);



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/array-slice.js
// module id = 210
// module chunks = 0